import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {scrolledToActivity} from 'shared/portfolio/actions/activities';
import {yearsToRanges} from 'shared/portfolio/utils';
import {Store} from 'src/types/store';

import LeadershipPosition from './leadership-position';
import Text from 'shared/components/text';
import {Activity as ActivityType} from './activities-form-wrapper';

interface Props {
  activity: ActivityType;
  hover?: boolean;
}

const Activity = ({activity, hover}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const institution = useSelector((state: Store) =>
    activity.institutionId ? state.institutions[activity.institutionId] : null
  );

  useEffect(() => {
    if (activity.scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToActivity(activity._id));
      }, 550);
    }
  }, [activity._id, dispatch, activity.scrollTo]);

  const organizationName = institution?.name || activity.organization;

  return (
    <div ref={ref}>
      <div className="portfolio-sections header-container larger-left-side">
        <div className="portfolio-sections card-header">
          <Text header emphasis inline weight={4} hover={hover}>
            <span dangerouslySetInnerHTML={{__html: activity.name}} />
          </Text>
        </div>
        {hover || (
          <Text inline weight={5} hover={hover} className="portfolio-sections year-ranges">
            {yearsToRanges(activity.schoolYears).join(', ')}
          </Text>
        )}
      </div>
      {organizationName && (
        <Text weight={5} hover={hover}>
          {organizationName}
        </Text>
      )}
      {activity.description && (
        <Text weight={5} hover={hover} color="darkgrey">
          {activity.description}
        </Text>
      )}
      {activity.leadershipPositions.map((leadershipPosition) => (
        <LeadershipPosition
          key={leadershipPosition._id}
          leadershipPosition={leadershipPosition}
          hover={hover}
        />
      ))}
    </div>
  );
};

export default Activity;
